import { render, staticRenderFns } from "./ErpMoneyStrongbox.vue?vue&type=template&id=29a707d6&"
import script from "./ErpMoneyStrongbox.vue?vue&type=script&lang=js&"
export * from "./ErpMoneyStrongbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports